import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className="footer-container">
            <span className="footer-header"></span>
        </div>
    );
}

export default Footer;
